import { lazy } from 'react';
import { CHUNK_RELOAD_SESSION_KEY, isChunkLoadError } from './chunkLoadError';

async function importWithChunkRetry(importer) {
  try {
    const module = await importer();
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
    }
    return module;
  } catch (error) {
    if (!isChunkLoadError(error) || typeof window === 'undefined') {
      throw error;
    }

    const hasReloaded = window.sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY) === '1';
    if (!hasReloaded) {
      window.sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, '1');
      window.location.reload();
      return new Promise(() => {});
    }

    window.sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
    throw error;
  }
}

export function lazyWithRetry(importer) {
  return lazy(() => importWithChunkRetry(importer));
}
